import { shaparakService } from "@/common/api.service"

const initialStates = {
    status: 'loading',
    shaparak_requests: []
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    setShaparakRequests(state, shaparak_requests) {
        state.status = 'setShaparakRequests'
        state.shaparak_requests = shaparak_requests
    }
}

const getters = {
    status: ({status}) => status,
    shaparak_requests: ({shaparak_requests}) => shaparak_requests
}

const actions = {
    fetchShaparakRequests({commit}, hashid) {
        commit('loading')
        return shaparakService.fetchShaparak(hashid).then(response => {
            commit('setShaparakRequests', response.data.data)
        })
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}